import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const WorkFlowListDetails = () => {
    const columns = [
        { label: 'Workflow Name', value: 'workflow_name' },
        { label: 'Trigger', value: 'trigger' },
        { label: 'Assigned To', value: 'assigned_to_name' },
        { label: 'Status', value: 'status' },
        {
            label: 'Access Details',
            value: (workflowId) => (
                <button onClick={() => handleAccessDetails(workflowId)}>Access Details</button>
            ),
        },
    ];

    const handleAccessDetails = (workflowId) => {
        //console.log('Access Details', workflowId);
        const encodedId = btoa(workflowId);
        window.location.href = `/workflow/details/${encodedId}`;
    };

    return <ListTemplate columns={columns} onAccessDetails={handleAccessDetails} fetchUrl={API_DOMAIN + API_ROUTES.workflow} />;
};

export default WorkFlowListDetails;
